import React, { useState, useRef, useEffect } from 'react';

interface HeaderProps {
  onAddFont: () => void;
  onClearFonts: () => void;
  onShowAbout: () => void;
  onPrintWorksheet: () => void;
  customFontCount: number;
}

const Header: React.FC<HeaderProps> = ({ onAddFont, onClearFonts, onShowAbout, onPrintWorksheet, customFontCount }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="bg-[#3B82F6] text-white px-4 py-3 flex justify-between items-center relative">
      <h1 className="font-bold text-lg">汉字练字助手</h1>
      <div className="relative" ref={menuRef}>
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="text-sm bg-white/20 px-3 py-1 rounded-full hover:bg-white/30 transition flex items-center"
        >
          <i className="fa fa-bars mr-1"></i>菜单
        </button>
        {menuOpen && (
          <div className="absolute right-0 top-full mt-2 w-44 bg-white rounded-lg shadow-lg border border-gray-100 py-1 z-50">
            <button
              onClick={() => { onAddFont(); setMenuOpen(false); }}
              className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 flex items-center"
            >
              <i className="fa fa-plus text-[#3B82F6] w-5"></i>添加字体
            </button>
            <button
              onClick={() => { onClearFonts(); setMenuOpen(false); }}
              className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 flex items-center disabled:opacity-40 disabled:cursor-not-allowed"
              disabled={customFontCount === 0}
            >
              <i className="fa fa-trash text-red-500 w-5"></i>清除缓存
              {customFontCount > 0 && (
                <span className="ml-auto text-xs text-gray-400">{customFontCount}</span>
              )}
            </button>
            <button
              onClick={() => { onPrintWorksheet(); setMenuOpen(false); }}
              className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 flex items-center"
            >
              <i className="fa fa-print text-[#3B82F6] w-5"></i>打印字帖
            </button>
            <div className="border-t border-gray-100 my-1"></div>
            <button
              onClick={() => { onShowAbout(); setMenuOpen(false); }}
              className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 flex items-center"
            >
              <i className="fa fa-info-circle text-[#3B82F6] w-5"></i>关于
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
